import React from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './app';
import './countdown.scss';

const countdownId = document.getElementById('countdownID');
if (countdownId) {
  const dataSet = countdownId.dataset;

  const root = createRoot(countdownId);
  root.render(<App endDate={new Date(dataSet.endDate)} />);
}
